// ============================================================================
// frontend/src/components/tenant/BrandingSection.tsx
// ============================================================================

import React from 'react';
import { TenantFormData } from '@/types/tenant';

interface BrandingSectionProps {
  formData: TenantFormData;
  handleFileChange: (field: string, file: File | null) => void;
}

export const BrandingSection: React.FC<BrandingSectionProps> = ({
  formData,
  handleFileChange
}) => {
  return (
    <div className="rounded-lg border bg-card p-6 space-y-6">
      <h2 className="text-xl font-semibold border-b pb-3">🎨 Branding & Assets</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label htmlFor="logo_light" className="text-sm font-medium">
            Logo (Mode clair)
          </label>
          <input
            id="logo_light"
            type="file"
            accept="image/png,image/svg+xml"
            onChange={(e) => handleFileChange('logo_light', e.target.files?.[0] || null)}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium"
          />
          {formData.logo_light && (
            <p className="text-xs text-green-600">✓ {formData.logo_light.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="logo_dark" className="text-sm font-medium">
            Logo (Mode sombre)
          </label>
          <input
            id="logo_dark"
            type="file"
            accept="image/png,image/svg+xml"
            onChange={(e) => handleFileChange('logo_dark', e.target.files?.[0] || null)}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium"
          />
          {formData.logo_dark && (
            <p className="text-xs text-green-600">✓ {formData.logo_dark.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="favicon" className="text-sm font-medium">
            Favicon
          </label>
          <input
            id="favicon"
            type="file"
            accept="image/x-icon,image/png"
            onChange={(e) => handleFileChange('favicon', e.target.files?.[0] || null)}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium"
          />
          {formData.favicon && (
            <p className="text-xs text-green-600">✓ {formData.favicon.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="login_page_image" className="text-sm font-medium">
            Image de fond (connexion)
          </label>
          <input
            id="login_page_image"
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={(e) => handleFileChange('login_page_image', e.target.files?.[0] || null)}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium"
          />
          {formData.login_page_image && (
            <p className="text-xs text-green-600">✓ {formData.login_page_image.name}</p>
          )}
        </div>
      </div>
    </div>
  );
};